var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_42)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5072 1.01495C7.28424 1.33444 1.40579 6.93072 1.02077 13.8574C0.704464 19.5441 4.03136 24.5174 8.96265 26.8283C10.8014 27.6896 12.9891 26.6069 13.3442 24.6738C13.583 23.373 12.8931 22.0815 11.657 21.5C8.85165 20.1789 6.96969 17.3313 7.19173 14.0848C7.45164 10.288 10.6534 7.20457 14.6102 6.94255C19.2896 6.63235 23.1856 10.1815 23.1856 14.6037C23.1856 17.639 21.3495 20.2617 18.6843 21.5084C17.4675 22.0773 16.8005 23.362 17.0359 24.6408L17.0482 24.7059C17.3971 26.6069 19.5443 27.6896 21.3548 26.8486C26.0923 24.6476 29.3601 19.9929 29.3601 14.6037C29.3592 6.87662 22.6438 0.654032 14.5072 1.01495Z",
    fill: "#00AA13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1925 19.3927C12.4393 19.3927 10.1996 17.2441 10.1996 14.6028C10.1996 11.9614 12.4393 9.81287 15.1925 9.81287C17.9458 9.81287 20.1855 11.9614 20.1855 14.6028C20.1855 17.2441 17.9458 19.3927 15.1925 19.3927Z",
    fill: "#00AA13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 27,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreen);
export default __webpack_public_path__ + "static/media/icon_green.ba64f13c8d07d776418cbcbf8a09c246.svg";
export { ForwardRef as ReactComponent };